import { createContext, useContext, useEffect, useState } from "react";
import api, { TOKEN_KEY, USER_KEY, localApi } from "@/lib/api";
import { applyBrandColor } from "@/lib/brand";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  // null = verificando sesión, false = no autenticado, objeto = autenticado
  const [user, setUser] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem(TOKEN_KEY);
    const saved = localStorage.getItem(USER_KEY);
    if (token && saved) {
      try {
        setUser(JSON.parse(saved));
        // Verifica que la empresa siga activa (el superadmin puede suspenderla)
        localApi.post("/tenant/ping").then((r) => {
          if (r.data?.active === false) logout();
        }).catch(() => {});
        return;
      } catch {
        /* datos corruptos */
      }
    }
    setUser(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const login = async (username, password) => {
    const { data } = await api.post("/auth/login", { username, password });
    localStorage.setItem(TOKEN_KEY, data.access_token);
    const u = {
      username: data.username,
      full_name: data.full_name,
      role: data.role,
      employee_id: data.employee_id,
    };
    localStorage.setItem(USER_KEY, JSON.stringify(u));
    setUser(u);
    try {
      const r = await localApi.post("/tenant/ping");
      const brand = r.data?.theme?.primary || null;
      applyBrandColor(brand);
      if (brand) localStorage.setItem("caus_brand", JSON.stringify({ primary: brand }));
      else localStorage.removeItem("caus_brand");
      if (r.data?.active === false) {
        localStorage.removeItem(TOKEN_KEY);
        localStorage.removeItem(USER_KEY);
        localStorage.removeItem("caus_brand");
        applyBrandColor(null);
        setUser(false);
        throw { response: { data: { detail: "Tu empresa está suspendida por falta de pago. Contacta al administrador de la plataforma para reactivar el acceso." } } };
      }
    } catch (err) {
      if (err?.response?.data?.detail?.includes("suspendida")) throw err;
      /* ping opcional */
    }
    return u;
  };

  const logout = () => {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(USER_KEY);
    localStorage.removeItem("caus_brand");
    applyBrandColor(null);
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
